export function removeDialCode(phone: string, dialCode: string): string {
	// Remove leading "+" if present
	const normalizedPhone = phone.startsWith("+") ? phone.slice(1) : phone;

	// Remove the dial code if it matches at the start
	if (normalizedPhone.startsWith(dialCode)) {
		return normalizedPhone.slice(dialCode.length);
	}
	return normalizedPhone;
}
